Apt.fn.make('product', {
	/**
	 * Initialize module
	 */
	init: function() {
		var priv = this.$private,
			id = $$('product').data('id');

		// Add class to body
		if ($$('product').length) {
			$('body').addClass('product-page');
		}

		// Initialize zoom functionality first
		priv.initZoom();

		priv.loadVariants(id);
		priv.bindGallery();
		priv.bindCta(id);
		priv.bindWishlist(id);

		CF.util.idle(function() {
			priv.loadRelated(id);
		});

		if ($.routes.uri().hash === 'print') {
			$._win.print();
		}
	},

	/**
	 * Unload module
	 */
	unload: function() {
		var scope = this;

		$.events.reset('product');
		$.scroll.reset('product');

		$$('productCta').remove();

		if (scope.zoom) {
			scope.zoom.$destroy();

			delete scope.zoom;
		}
	}
}, {
	/**
	 * Initialize zoom and lightbox functionality
	 */
	initZoom: function() {
		var scope = this;

		// Create a single zoom object with lightbox functionality
		scope.zoom = {
			// Apply lightbox functionality to the product image
			applyLightbox: function($image) {
				if (!$image || !$image.length) {
					return;
				}

				// Remove any existing click handlers and add a new one
				$image.off('click').on('click', function(e) {
					e.preventDefault();
					e.stopPropagation();

					var src = $image.data('large');
					var alt = $image.attr('alt') || 'Product image';
					var content = `<div class="product-lightbox-container">
						<img class="product-lightbox-image" src="${src}" alt="${alt}">
					</div>`;

					Apt.modal.open({
						content: content,
						modalClass: 'product-lightbox',
						mask: true,
						close: true
					});

					return false;
				});
			},

			// Restore lightbox functionality after image changes
			restore: function() {
				var $image = $$('productImage');
				if ($image.length) {
					// Short delay to ensure the image has been updated
					setTimeout(function() {
						scope.zoom.applyLightbox($image);
					}, 50);
				}
			},

			// Cleanup method
			$destroy: function() {
				var $image = $$('productImage');
				if ($image.length) {
					$image.off('click');
				}
			}
		};

		// Apply initial lightbox functionality
		scope.zoom.restore();
	},

	/**
	 * Load product variants
	 *
	 * @param {Number} id
	 */
	loadVariants: function(id) {
		var scope = this,
			$variants = $$('variants');

		if (! $variants.length) {
			return;
		}

		var $sku = $$('productSku'),
			$image = $$('productImage');

		$.fetch.request({
			url: '/api/v1/product/' + id + '/variants',
			json: true,
			success: function(data) {
				var selections = {},
					requirements = 0,
					fields = Object.keys(data.meta.fields),
					fieldCount;

				data.data.forEach(function(variant) {
					if (variant.fields) {
						fieldCount = 0;

						Object.keys(variant.fields).forEach(function(field) {
							if (fields.indexOf(field) >= 0) {
								fieldCount++;
							}
						});

						if (! requirements || fieldCount < requirements) {
							requirements = fieldCount;
						}
					}
				});

				fields.forEach(function(field) {
					if (field === 'productFinish') {
						selections[field] = 1237;
					}

					if (
						field === 'productHandle' &&
						data.meta.fields.productHandle.values &&
						data.meta.fields.productHandle.values.every(function(value) {
							return value.thumb === '';
						})
					) {
						delete data.meta.fields.productHandle;
					}
				});

				scope.variants = $.app.make('variants', {
					target: $variants,
					view: 'product.variants',
					model: data
				});

				$$('variantGroup').each(function(el) {
					var $group = $(el),
						$variants = $group.find('ref:variant'),
						$variant,
						offset,
						top,
						i = 0,
						isHandle = false;

					if ($group.data('field') === 'productHandle') {
						isHandle = true;
					}

					for (; i < $variants.length; i++) {
						$variant = $variants.eq(i);
						top = $variant.offset().top;

						if (isHandle && i === 0) {
							$variant.addClass('-is-active');
							selections[$group.data('field')] = $variant.data('id');
						}

						if (offset && top !== offset) {
							$group.find('ref:variantExpand')
							.show();
						}

						offset = top;
					}
				});

				$$('variant').on('click', function(e, el) {
					var $el = $(el),
						$group = $el.closest('ref:variantGroup'),
						field = $group.data('field');

					if ($el.hasClass('-is-active')) {
						$el.removeClass('-is-active');

						$group.find('ref:variantValue')
							.hide();

						delete selections[field];
					} else {
						$el.addClass('-is-active')
							.siblings()
							.removeClass('-is-active');

						$group.find('ref:variantValue')
							.text($el.data('title'))
							.show();

						selections[field] = $el.data('id');
					}

					var selected = Object.keys(selections).length,
						matches,
						selection,
						variant,
						match,
						image,
						i = 0;

					for (; i < data.data.length; i++) {
						variant = data.data[i];
						matches = 0;

						for (selection in selections) {
							if (variant.fields[selection] === selections[selection]) {
								matches++;
							}
						}

						if (matches >= requirements && matches === selected) {
							match = variant;
							break;
						}
					}

					if (match) {
						console.log('Match found:', match);
						var smallImage = match.fields.image;
						var largeImage = match.fields.imageLarge;

						if (smallImage) {
						    $image.attr('src', smallImage)
							$image.data('small', smallImage)
							$image.data('large', largeImage || smallImage)
							$image.attr('alt', match.fields.title || 'Product variant image');

							$$('productGallery').toggleClass('-is-missing', false);
						} else {
                            $$('productGallery').toggleClass('-is-missing', true);
						}

						$sku.text(match.sku)
							.data('id', match.id);

						scope.zoom.restore();

						if ($.screen.size() < 3) {
							$.animate.tween($._body, {
								scrollTop: $$('product').offset().top
							});
						}
						scope.updateWishlist(match.id);
					} else {
						$sku.text('Model ' + $sku.data('model'))
							.data('id', id);

						var imageUrl = $image.data('src');
						if ($image.length && imageUrl) {
							scope.zoom.restore();
							$image.attr('src', imageUrl);
							$$('productGallery').toggleClass('-is-missing', false);
						} else {
							$$('productGallery').toggleClass('-is-missing', true);
						}

						scope.updateWishlist(id);
					}
				}, {
					namespace: 'product'
				});

				$$('variantExpand').on('click', function(e, el) {
					$(el).hide()
						.closest('ref:variantGroup')
						.addClass('-is-expanded');
				}, {
					namespace: 'product'
				});
			}
		});
	},

	/**
	 * Load related products
	 *
	 * @param {Number} id
	 */
	loadRelated: function(id) {
		$.fetch.request({
			url: '/api/v1/catalog',
			data: {
				related: id,
				limit: 4
			},
			json: true,
			success: function(response) {
				if (! response.data || response.data.length < 3) {
					return;
				}

				$$('relatedProducts').html(
					$.view.render('catalog.results', {
						results: response.data,
						modifier: 'wide'
					})
				);

				$$('related').show();

				Apt.wishlists.highlight();
				Apt.wishlists.bind('product', 'ref:relatedProducts');
			}
		});
	},

	/**
	 * Bind gallery modal
	 */
	bindGallery: function() {
		var scope = this,
			$image = $$('productImage'),
			$video = $$('productVideo'),
			$download = $$('productDownload'),
			$thumbs = $$('thumb'),
			activeClass = '-is-active';

		// Thumbnail click handler (replaces main image)
		$thumbs.on('click', function(e, el) {
			var $thumb = $(el),
				smallSrc = $thumb.data('small'),
				largeSrc = $thumb.data('large'),
				videoId = $thumb.data('video');

			$thumbs.removeClass(activeClass);
			$thumb.addClass(activeClass);

			if (videoId) {
				$video.addClass('-is-active')
					.html(`<iframe src="https://player.vimeo.com/video/${videoId}?autoplay=1" allow="autoplay; fullscreen" allowfullscreen></iframe>`);
				$image.attr('src', largeSrc);
			} else {
				$video.removeClass('-is-active')
					.html('');
				$image.attr('src', smallSrc);
				$image.data('small', smallSrc);
				$image.data('large', largeSrc);
			}

			// Reapply lightbox functionality after changing the image
			scope.zoom.restore();
		}, {
			namespace: 'product'
		});

		$download.on('click', function() {
			var largeSrc = $$('productImage').data('large');
			if (largeSrc) {
				$download.attr('href', largeSrc)
					.attr('download', $$('productSku').data('model'));
			}
		}, {
			namespace: 'product'
		});
	},

	/**
	 * Bind CTA actions
	 *
	 * @param {Number} id
	 */
	bindCta: function(id) {
		var scope = this,
			$cta = $$('productCta'),
			lockedClass = '-is-locked';

		$.scroll.map([
			{
				target: 'ref:footer',
				callback: function() {
					$cta.appendTo('ref:footer')
						.addClass(lockedClass);
				}
			},
			{
				target: 'ref:footer',
				threshold: -1,
				callback: function() {
					$cta.removeClass(lockedClass);
				}
			}
		], {
			namespace: 'product'
		});

		$.events.on({
			'ref:productShare': {
				click: function() {
					scope.share = Apt.fn.share()
						.init({
							target: 'product',
							id: id
						});
				}
			},
			'ref:productPrint': {
				click: function() {
					$._win.print();
				}
			}
		}, {
			namespace: 'product'
		});
	},

	/**
	 * Bind wishlist functionality
	 *
	 * @param {Number} id
	 */
	bindWishlist: function(id) {
		var scope = this;

		scope.updateWishlist(id);

		$$('productWishlist').on('click', function() {
			id = $$('productSku').data('id') || id;

			// Check if user is logged in
			if (Apt.wishlists.$get('userId')) {
				// For logged-in users, show the selection modal
				Apt.wishlists.prompt(id, function() {
					scope.updateWishlist(id);
				});
			} else {
				// For guest users, directly toggle the wishlist item
				Apt.wishlists.toggle(id, null, function(state) {
					scope.updateWishlist(id);
				});
			}
		}, {
			namespace: 'product'
		});
	},

	/**
	 * Toggle wishlist status
	 *
	 * @param {Number} id
	 */
	updateWishlist: function(id) {
		Apt.wishlists.exists(id, function(status) {
			$$('productWishlist').toggleClass('-is-active', status);
		});
	}
});
